import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Typography, Dialog, Button, Avatar, TextField, Popover } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles'
import { useStyles, theme } from '../styles/StudyplusPopStyle'

export default function StudyplusPop({ openForMenu, setOpenForMenu }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [code, setCode] = useState(window.currentUser.appId ? window.currentUser.appId : '')
  const [anchorEl, setAnchorEl] = useState(null)

  // メニュー「連携コードを確認」をクリックした場合
  useEffect(() => {
    if (openForMenu) {
      setOpen(true)
    } else {
      defaultOpenState()
    }
  }, [openForMenu])

  // ローカルストレージの有無で初回判定
  const defaultOpenState = () => {
    if (!localStorage.getItem('disp_popup')) {
      localStorage.setItem('disp_popup', 'on')
      setOpen(true)
    } else {
      setOpen(false)
    }
  }

  // ポップアップ閉
  const handleClose = () => {
    setOpen(false)
    setOpenForMenu(!openForMenu)
    setAnchorEl(null)
  }

  // コピーボタン押下
  const handleClick = e => {
    setAnchorEl(e.currentTarget)
  }
  const copied = Boolean(anchorEl)
  const id = copied ? "simple-popover" : undefined

  return (
    <ThemeProvider theme={theme}>
      <Dialog onClose={handleClose} open={open}>
        <div className={classes.row}>
          <Typography variant="body2" component="h2" className={classes.dialogTitle}>
            Studyplusと<br />連携しよう！
          </Typography>
          <Avatar
            src="/images/studyplus-icon.png"
            variant="square"
            style={{ width: 66, height: 66 }}
          />
        </div>
        <Typography variant="subtitle2" component="h2" align="center" className={classes.subText}>
          あなた専用の連携コード
        </Typography>
        <div className={classes.inputArea}>
          <TextField
            id="outlined-basic"
            variant="outlined"
            disabled
            value={code}
            InputProps={{
              classes: {
                root: classes.notchedOutline,
                focused: classes.notchedOutline,
                notchedOutline: classes.notchedOutline,
              },
            }}
          />
          <CopyToClipboard text={code} onCopy={() => console.log('copied!')}>
            <Button variant="contained" onClick={e => handleClick(e)} size="small" className={classes.copyBtn}>
              コピー
            </Button>
          </CopyToClipboard>
          <Popover
            id={id}
            open={copied}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Typography className={classes.popText}>Copied!</Typography>
          </Popover>
        </div>
        <Button
          variant="contained"
          className={classes.appBtn}
          href="https://studyplus.page.link/qLo3"
          target="_blank"
        >
          Studyplusアプリを開く
        </Button>
        <Typography className={classes.noteText} align="center">上記ボタンはスマートフォンからのみ有効です</Typography>
      </Dialog>
    </ThemeProvider>
  )
}

if (document.getElementById('studyplus_pop')) {
  ReactDOM.render(
    <StudyplusPop />,
    document.getElementById('studyplus_pop')
  )
}